import { v4 as uuidv4 } from 'uuid'
import { kuiperClassNames } from '@opallabs/kuiper'
import { newDateObject } from '../helpers/dateHelpers'
import { isApproval, isTask, WorkflowLocation } from '../helpers/matchers'

export const makeDue = (dueDate) =>
  newDateObject(dueDate === undefined ? null : dueDate)

export const phaseActions = {
  Delete: 'delete',
  MoveDown: 'moveDown',
  MoveUp: 'moveUp',
  Resend: 'resend',
  Retract: 'retract',
}

export function newPhaseItem(arrayManager, phaseItems) {
  const itemCount = phaseItems.length
  const newPosition = arrayManager.insertAt(phaseItems, itemCount)[itemCount]
  const position =
    newPosition === 0 ? 0 : newPosition || Number.MAX_SAFE_INTEGER

  const newItem = {
    isPlaceholder: true,
    position,
    uuid: uuidv4(),
  }
  return newItem
}

export const getItems = (props) => {
  if (props.items && props.items.length) {
    return props.items
  }
  if (props.approvals && props.approvals.length) {
    return props.approvals
  }
  if (props.tasks && props.tasks.length) {
    return props.tasks
  }
  return []
}

export const isFuturePhase = ({ is_active, is_complete, is_current }) =>
  !is_active && !is_complete && !is_current

export const classNames = ({ className, disabled, expanded, phase, theme }) =>
  kuiperClassNames(className, 'phase', `theme-${theme}`, {
    active: phase.is_active && !phase.is_complete,
    approvals: isApproval(phase.phase_type),
    complete: phase.is_complete,
    current: phase.is_current,
    disabled,
    expanded,
    finalApproval: phase.isFinalApproval,
    futurePhase: isFuturePhase(phase),
    inactive: !phase.is_current || phase.is_complete,
    tasks: isTask(phase.phase_type),
  })

export const updateApprovalItemStatus = (approvalItems, retract = false) =>
  approvalItems.map((item) => {
    let status

    if (retract) {
      status = 'initial'
    } else if (item.status !== 'approved') {
      status = 'pending'
    } else {
      status = item.status
    }

    return {
      ...item,
      status,
    }
  })

export const shouldRenderFooter = (isComplete, workflowLocation) =>
  !isComplete && workflowLocation !== WorkflowLocation.Popover

export const canExpand = ({
  is_active,
  is_complete,
  is_current,
  workflowLocation,
}) => {
  if (is_complete) {
    return true
  }
  const futurePhase = isFuturePhase({ is_active, is_complete, is_current })
  return futurePhase && workflowLocation === WorkflowLocation.Popover
}
